import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inputCls, labelCls, btnPrimary } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PasswordDialog = ({ open, onOpenChange, onLogout }) => {
  const [f, setF] = useState({ cur: "", nw: "", conf: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.nw.length < 8) return toast.error("A nova senha precisa ter pelo menos 8 caracteres.");
    if (f.nw !== f.conf) return toast.error("A confirmação não confere.");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: f.cur, new_password: f.nw });
      toast.success("Senha trocada! Entre novamente.");
      onOpenChange(false);
      setTimeout(onLogout, 600);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao trocar senha");
    }
    setLoading(false);
  };

  const field = (k, label, testId) => (
    <div>
      <label className={labelCls}>{label}</label>
      <input type="password" required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
        className={inputCls} data-testid={testId} />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setTimeout(() => setF({ cur: "", nw: "", conf: "" }), 200); }}>
      <DialogContent className="bg-white text-slate-900 border-[#EDE6DA] rounded-3xl" style={{ fontFamily: "Outfit, sans-serif" }}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-slate-900"><KeyRound size={18} className="text-[#0A66C2]" /> Trocar senha</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {field("cur", "Senha atual", "pwd-current-input")}
          {field("nw", "Nova senha (mín. 8)", "pwd-new-input")}
          {field("conf", "Confirmar nova senha", "pwd-confirm-input")}
          <button type="submit" disabled={loading} className={`${btnPrimary} w-full`} data-testid="pwd-submit-button">
            {loading ? "Trocando..." : "Trocar senha"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
